import { createRouter, createWebHistory } from 'vue-router';
import { useAppStore } from '@/stores/appstore';
import Login from '@/views/shared/login.vue';

import NProgress from 'nprogress';
NProgress.configure({ easing: 'ease', speed: 1500 });


const routes = [
    {
        path: '/',
        name: 'Login',
        component: Login,
        meta: {
            hideNavbar: true,
            hideFooter: true,
            requiresAuthentication: false,
        }
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('@/views/shared/dashboard.vue'),
        meta: {
            requiresAuthentication: true,
            hideNavbar: false,
            hideFooter: false,
        }
    },
    // Admin management routes
    {
        path: '/admin/listings',
        name: 'admin-listings',
        component: () => import('@/views/admin/listings.vue'),
        meta: {
            requiresAuthentication: true,
            requiresAdmin: true,
        }
    },
     {
        path: '/listing/detail/:reference',
        name: 'room-detail',
        component: () => import('@/views/shared/room-detail.vue'),
        meta: {
            title: (route) => {
                let reference = route.params.reference;
                return `Details for room #${reference}`;
            }
        }
    },
    {
        path: '/admin/requests',
        name: 'admin-requests',
        component: () => import('@/views/admin/requests.vue'),
        meta: {
            requiresAuthentication: true,
            requiresAdmin: true,
        }
    },
    {
        path: '/admin/subscriptions',
        name: 'admin-subscriptions',
        component: () => import('@/views/admin/subscriptions.vue'),
        meta: {
            requiresAuthentication: true,
            requiresAdmin: true,
        }
    },
    {
        path: '/admin/payments',
        name: 'admin-payments',
        component: () => import('@/views/admin/payments.vue'),
        meta: {
            requiresAuthentication: true,
            requiresAdmin: true,
        }
    },
    {
        path: '/admin/users',
        name: 'admin-users',
        component: () => import('@/views/admin/users.vue'),
        meta: {
            requiresAuthentication: true,
            requiresAdmin: true,
        }
    },
    // Financier routes
    {
        path: '/financier/financing-requests',
        name: 'financier-financing-requests',
        component: () => import('@/views/financier/financing-requests.vue'),
        meta: {
            requiresAuthentication: true,
            requiresFinancier: true,
        }
    },
    {
        path: '/financier/financing-requests/:id',
        name: 'financier-financing-request-detail',
        component: () => import('@/views/financier/financing-request-detail.vue'),
        meta: {
            requiresAuthentication: true,
            requiresFinancier: true,
        }
    },
    {
        path: '/dashboard/invoice',
        name: 'subscriber-invoice',
        component: () => import('@/components/dashboard/subscriber/invoice.vue'),
        meta: {
            requiresAuthentication: true,
        }
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve({ left: 0, top: 0 })
            }, 200)
        })
    }
});

//Todo: Add check for authentication token expiry
router.beforeEach((to, from) => {
    NProgress.start();
    const store = useAppStore();
    if (!store.IsAuthenticated && to.meta.requiresAuthentication === true) {
        NProgress.done();
        return { name: 'Login' };
    }
    
    // Check if route requires admin access
    if (to.meta.requiresAdmin && store.User.userType !== 'Admin') {
        NProgress.done();
        return { name: 'dashboard' };
    }
    
    // Check if route requires financier access
    if (to.meta.requiresFinancier && store.User.userType !== 'Financier') {
        NProgress.done();
        return { name: 'dashboard' };
    }
    
    NProgress.done();

})

export default router
